export default __webpack_public_path__ + "static/media/collapse.d4b032d3.svg";